<div id="langSelect" *ngIf="availableLanguages.length > 1">
  <p-dropdown
    #dropdown
    [(ngModel)]="selectedLanguage"
    [options]="availableLanguages"
    optionLabel="translatedValue"
    (onChange)="updateLanguage($event)"
    class="fix"
  >
  </p-dropdown>
</div>
